<template>
  <div class="traces-main">
    <div class="main-title">
      <span/>{{ selected.name }}
    </div>
    <el-dropdown style="vertical-align: middle;">
      <span style="color: #2dc26b;margin-left: 10px;cursor: pointer">
        更多课程
        <i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <template #dropdown>
        <el-dropdown-menu vslot="dropdown" >
          <el-dropdown-item @click="coursesChangerHandel(data)" :key="index" v-for="(data,index) in courses">{{data.name}}</el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>
    
    <div style="display: inline-block;margin-left: 82px;">
        <el-popover
          placement="bottom-start"
          title="图示说明"
          width="200"
          trigger="hover">
          <template #reference>
            <el-button type="danger">图示说明</el-button>
          </template>
          <img style="width: 280px;height: 145.25px;" src='../../../public/images/henjishuoming.png'>
        </el-popover>
    </div>

    <div class="main-content">
      <div class="content-left" v-if="workInfo">
        <div class="left-work" >
          <div class="work-title">主观题</div>
          <div @click="toWorking" class="work-content demo-progress">
            <div>
              <span class="text">{{workInfo.subjective_passed}}</span>
              <el-progress
                :width="100"
                :color="workInfo.subjective_colour"
                :stroke-width="14"
                type="dashboard"
                :percentage="workInfo.subjective_percentage"
              >
                <span class="percentage-label">通过{{workInfo.subjective_percentage}}%</span>
              </el-progress>
              <span class="text">{{workInfo.subjectives}}</span>
            </div>
          </div>
        </div>
        <div
          class="left-work"
          :style="{ 'background-color': '#aeaeae', 'margin-top': '20px' }"
        >
          <div class="work-title">客观题</div>
          <div @click="toWorking" class="work-content demo-progress">
            <div >
              <span class="text">{{workInfo.objective_pass}}</span>
              <el-progress
                :width="100"
                :color="workInfo.objective_colour"
                :stroke-width="14"
                type="dashboard"
                :percentage="workInfo.objective_percentage"
              >
                <span class="percentage-label">正确{{workInfo.objective_percentage}}%</span>
              </el-progress>
              <span class="text">{{workInfo.objectives}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="content-right">
        <div
          class="right-list"
          v-for="(itemClass, indexClass) in criterionData.class"
          :key="indexClass"
        >
          <div class="list-child list-title">{{ itemClass.className }}</div>
          <div
              class="work-content demo-progress list-child"
              v-for="(itemsType, indexType) in itemClass.type"
              :key="indexType"
              @click="clickHandel(itemsType)"
          >
            <div v-show="itemsType.status === 1">
              <el-progress
                  :stroke-width="14"
                  type="dashboard"
                  :percentage="(itemsType.value / itemsType.number) < 1 ? (itemsType.value / itemsType.number)*100 : 100"
                  :color="itemsType.color"
              >
                <span class="percentage-label">{{ itemsType.typeName }}<span style="color: #2dc26b">({{itemsType.unit}})</span></span
                ><span class="percentage-prompt">
                  {{ itemsType.description }}</span
              >
              </el-progress>
              <span class="text">{{ itemsType.value }}</span>
              <span class="text-right">{{ itemsType.number }}</span>
            </div>
            <div v-show="itemsType.status === 0" class="list-child">
              <div class="thumbs-up">
                <h2>
                  <span>{{ itemsType.value }}</span>
                  <span style="color: #2dc26b;font-weight: normal;font-size: 14px"> {{itemsType.unit}}</span>
                </h2>
                <p>{{ itemsType.typeName }}</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import {
  getcountevaluationcriterion,
  getHomeworkLearningTrace,
  queryTakingOrHavingTakenCourses
} from "@/api/Learn-traces";
import { useRouter } from "vue-router";
import { ref } from "vue";

//学习痕迹数据
let criterionData = ref({});

const workInfo = ref()
const courses=ref()
const selected=ref({})
const loadData=(course)=>{
  getcountevaluationcriterion({
    course_code:course.code,
    course_name:course.course_name,
    type: 1,
  }).then((res) => {
    criterionData.value = res.datas.data[0]
  })
  getHomeworkLearningTrace({
    course_code:course.code,
    course_name:course.course_name,
    type:1
  }).then(data => {
    workInfo.value=data.datas.data[0]
  })
}
queryTakingOrHavingTakenCourses({type: 1,}).then(data=>{
  courses.value=data.datas.data
  selected.value=courses.value[0]
  loadData(courses.value[0])
})

const coursesChangerHandel=(data)=>{
  selected.value=data
  loadData(data)
}
const router=useRouter()
const toWorking= ()=>{
  router.push(`/OnlineJob`)
}

const clickHandel =(data)=>{
  // 浏览
  const props ={
    courseCode:data.code,
    classId:data.class_id
  }
  if(data.type_id===2){
    router.push({
      path:"/Mine/MyBrowsing",
      query:props
    })
  }
  // 收藏
  if(data.type_id===10){
    router.push({
      path:"/Mine/MyFavorites",
      query:props
    })
  }
  if(data.type_id===1){
    router.push({
      path:"/Mine/MyView",
      query:props
    })
  }
  if(data.type_id===4){
    router.push({
      path:"/Mine/Praise",
      query:props
    })
  }
  if(data.type_id===3){
    router.push({
      path:"/Mine/Forum",
      query:props
    })
  }
}
</script>
<style lang="scss" scoped>
.traces-main {
  .pagination {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 20px;
  }
  .main-title {
    line-height: 90px;
    font-weight: 500;
    font-size: 25px;
    /* padding-left: 10px; */
    font-family: sans-serif;
    display: inline-block;
    span{
      display: inline-block;
      height: 20px;
      width: 5px;
      background: #fe5e14;
      border-radius: 10px;
      vertical-align: middle;
      margin-right: 10px;
    }
  }
  .main-content {
    display: flex;
    justify-content: space-between;
    .content-left {
      padding: 20px;
      // width: 280px;
      // min-height: 100px;
      background-color: white;
      display: flex;
      flex-direction: column;
      align-items: center;
      .left-work {
        padding: 10px;
        width: 200px;
        height: 180px;
        background-color: #1b8afe;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .work-title {
          color: white;
          font-size: 22px;
          // font-weight: bolder;
          line-height: 40px;
          margin-left: 10px;
        }
        .work-content {
          cursor: pointer;
          width: 100%;
          height: 130px;
          background-color: white;
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;
          .text {
            font-weight: bolder;
          }
        }
      }
    }

    .content-right {
      flex: 1;
      min-height: 460px;
      background-color: white;
      margin-left: 20px;
      overflow-y: auto;
      padding: 16px 0;
      // scrollbar-width: none;

      .right-list {
        display: flex;
        flex-wrap: wrap;
        .list-title {
          font-size: 20px;
          font-weight: bolder;
        }
        .work-content {
          .text {
            font-weight: bolder;
          }
          .text-right {
            font-weight: bolder;
            color: #cacaca;
            margin-left: 100px;
          }
        }
        .list-child {
          width: 150px;
          height: 150px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-wrap: wrap;
          .thumbs-up {
            width: 100px;
            height: 100px;
            border-radius: 30px;
            // border-image-source: linear-gradient(to top, #814ce4, #2b90fa) 1 10;
            // border-image: linear-gradient(to top, #2b90fa, #814ce4) 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            background-color: #f5f7fa;
            p {
              margin-top: 10px;
              width: 70px;
              line-height: 26px;
              background-color: #2b90fa;
              border-radius: 13px;
              text-align: center;
              color: white;
              font-size: 12px;
            }
          }
        }
        .list-Progress {
          padding: 0 20px;
          width: 300px;
          height: 150px;
          display: flex;
          align-items: center;
          position: relative;
          p {
            margin-top: 20px;
            color: #505050;
            font-size: 18px;
          }
          .list-Progress-prompt {
            position: absolute;
            top: 34px;
            left: 40px;
            width: 80px;
            line-height: 22px;
            background-color: #e9e9e9;
            text-align: center;
          }
        }
      }
    }
    ::-webkit-scrollbar {
      display: none; /* Chrome Safari */
    }
  }
}
</style>

<style scoped>
/* .el-slider {
  flex: 0 0 70%;
} */
.percentage-value {
  display: block;
  margin-top: 10px;
  font-size: 28px;
}
.percentage-label {
  display: block;
  margin-top: 10px;
  font-size: 12px;
}
.percentage-prompt {
  display: block;
  margin-top: 10px;
  font-size: 12px;
  color: #cacaca;
}
.demo-progress .el-progress--line {
  margin-bottom: 15px;
  width: 350px;
}
.demo-progress .el-progress--circle {
  margin-right: 15px;
}
</style>
